import * as React from "react";
import { createContext, useContext, useRef } from "react";
export var AudioContext = createContext({
    play: function () { },
    stop: function () { },
});
export var AudioProvider = function (_a) {
    var children = _a.children;
    var audioElement = useRef(new Audio());
    var play = function (audio, ariaLabel) {
        if (audioElement.current.src !== audio) {
            audioElement.current.src = audio;
        }
        if (ariaLabel &&
            ariaLabel !== audioElement.current.getAttribute("aria-label")) {
            audioElement.current.setAttribute("aria-label", ariaLabel);
        }
        audioElement.current.play();
    };
    var stop = function () {
        audioElement.current.pause();
    };
    return (React.createElement(AudioContext.Provider, { value: { play: play, stop: stop } }, children));
};
export var useAudio = function () {
    return useContext(AudioContext);
};
